import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css';

export const texts_settings_mixin = {
    components: { vSelect },
    data() {
        return {
            textsData: []
        }
    },
    inject: ['http'],
    methods: {    
        async getTexts() {
            this.textsData = await this.http.post('onGetTexts').then(res => res.data);
            console.log(this.textsData)
        },
        async initTexts() {
            await this.getTexts();
            this.checkTextId();
        },
        async checkTextId() {
            if (!this.params.text && this.params.text_id) {
                console.log('Check text id. No text. Loading');
                await this.onSelectText(this.params.text_id);
            }
        },
        async onSelectText(id = null) {
            let data = {
                'text_id': id ? id : this.params.text_id
            }
            this.params.text = await this.http.post('onGetFullText', data).then(res => res.data);
        }
    },
    mounted() {
        this.initTexts();
    }
}